var _circle, _circle2, _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsPowerPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_88464)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16,
    r: 14,
    fill: "url(#paint0_linear_5259_88464)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5259_88464",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 29,
    height: 28
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16,
    r: 14,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5259_88464)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    width: 17,
    height: 17,
    fill: "url(#paint1_linear_5259_88464)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C6.5 10.3431 7.84315 9 9.5 9H17.5C19.1569 9 20.5 10.3431 20.5 12V24C20.5 25.6569 19.1569 27 17.5 27H6.5V12Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    width: 17,
    height: 17,
    fill: "#EB6C4D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7,
    width: 18,
    height: 18,
    rx: 2,
    fill: "url(#paint2_linear_5259_88464)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.4571C13.5 12.3 12.0799 11 9.82787 11H6.5V21H8.56557V17.9571H9.7418C11.8504 17.9571 13.5 16.7571 13.5 14.4571ZM11.4057 14.5C11.4057 15.4714 10.7889 16.1 9.78484 16.1H8.56557V12.8714H9.77049C10.7746 12.8714 11.4057 13.4 11.4057 14.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5259_88464",
    x1: 3.5,
    y1: 17.931,
    x2: 31.5,
    y2: 17.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A73A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5259_88464",
    x1: 32,
    y1: 10,
    x2: 18.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1876D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5259_88464",
    x1: 0.5,
    y1: 17.2414,
    x2: 18.5,
    y2: 17.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A73A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F75936"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_88464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsPowerPoint);
export default __webpack_public_path__ + "static/media/MsPowerPoint.ccbabad3e0fa7e95b2fad141ce1e0502.svg";
export { ForwardRef as ReactComponent };